<template>
  <empty-state class="margin-auto mt-12" data-testid="backup-and-restore-activation-empty-state">
    <template #icon>
      <v-icon size="80" icon="$backupAndRestoreL" />
    </template>
    <template #description>
      <span>{{ $t("cloudBackupAndRestore.activationEmptyState.title") }}</span>
    </template>
    <template #subtitle>
      <span data-testid="backup-and-restore-activation-empty-state-subtitle">
        {{ subtitle }}
      </span>
    </template>
  </empty-state>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import EmptyState from "@/components/EmptyState.vue";
import { useWorkspaceStore } from "@/_store/workspace.module";

export default defineComponent({
  components: {
    EmptyState,
  },
  setup() {
    const i18n = useI18n();
    const { workspace } = storeToRefs(useWorkspaceStore());

    /**
     * Only a workspace's MSP can activate Cloud Backup for it, so the admin is pointed at
     * theirs by name. The name is not always known (a workspace switched into without the
     * hierarchy loaded reports an empty one), and "Contact ." is worse than saying
     * "your service provider", so the generic wording is used in that case.
     */
    const subtitle = computed(() =>
      workspace.value.parentWorkspaceName
        ? i18n.t("cloudBackupAndRestore.activationEmptyState.subtitle", {
            mspName: workspace.value.parentWorkspaceName,
          })
        : i18n.t("cloudBackupAndRestore.activationEmptyState.subtitleNoMspName")
    );

    return {
      subtitle,
    };
  },
});
</script>

<style lang="scss" scoped>
:deep(*) {
  .icon-backup-and-restore-l:before {
    color: rgb(var(--v-theme-indigo-light)) !important;
  }
}
</style>
